<template>
    <div class="guarantee-detail preview">
        <MyTitle theTitle="续保详情"/>
            <div class="fd-com-scroll">
                <Slogan theTitle="续保审查信息"/>
                <div ref="xxscxx">
                    <!--财产线索-->
                    <div v-if="xxbqjbxxData.nBqlx == '1'">
                        <van-swipe-cell
                            v-for="(item, index) in xxbqccxsData"
                            :key="item.cid">
                            <van-cell
                                title='财产类型'
                                :value=item.cCclx
                                :key="item.cid"
                                @click="goToScxxDeatil(item, item.cid, index)"
                            ></van-cell>
                        </van-swipe-cell>
                    </div>
                    <!--证据信息-->
                    <div v-if="xxbqjbxxData.nBqlx == '2'">
                        <van-swipe-cell v-for="(item, index) in xxbqzjxxData" :key="item.cid">
                            <van-cell
                                title='证据类型'
                                :value=item.nzjlx
                                :key="item.cid"
                                @click="goToScxxDeatil(item, item.cid, index)"
                            ></van-cell>
                        </van-swipe-cell>
                    </div>

                    <!--行为信息-->
                    <div v-if="xxbqjbxxData.nBqlx == '3'">
                        <van-swipe-cell
                            v-for="(item, index) in xxbqxwxxData"
                            :key="item.cid">
                            <van-cell
                                title='行为类型'
                                :value=item.nXwbqsx
                                :key="item.cid"
                                @click="goToScxxDeatil(item, item.cid, index)"
                            ></van-cell>
                        </van-swipe-cell>
                    </div>
                </div>
                <Slogan theTitle="基本信息"/>
                <!--        保全-执行信息预览 -->
                <div ref="jcbqjbxx">
                    <van-field
                        v-model="xxbqjbxxData.cSqfymc"
                        readonly
                        label="姓名"
                    ></van-field>
                    <van-field
                        v-model="xxbqjbxxData.cAh"
                        readonly
                        label="案号"
                    ></van-field>
                    <van-field
                        label="申请人"
                        readonly
                        v-model="xxbqjbxxData.cSqrmcs"
                    ></van-field>
                    <van-field
                        v-model="xxbqjbxxData.cSqxbyy"
                        readonly
                        label="续保事由"
                    ></van-field>
                    <van-field
                        v-model="xxbqjbxxData.cTjrsf"
                        readonly
                        label="提交人身份"
                    ></van-field>
                    <van-field
                        v-model="xxbqjbxxData.dtCreatetime"
                        readonly
                        label="创建申请日期"
                    ></van-field>
                    <van-field
                        v-model="xxbqjbxxData.cBz"
                        label="备注"
                        readonly
                    ></van-field>
                </div>

                <!--财产线索-->
                <div v-if="xxbqjbxxData.nBqlx == '1'">
                    <info-title title-content="财产线索"></info-title>
                    <van-swipe-cell
                        v-for="item in xxbqccxsData"
                        :key="item.cId">
                        <van-cell
                            title='财产类型'
                            :value=item.cCclx
                            :key="item.cId"
                        ></van-cell>
                    </van-swipe-cell>
                </div>

                <!--证据信息-->
                <div v-if="xxbqjbxxData.nBqlx == '2'">
                    <Slogan theTitle="证据信息"/>
                    <van-swipe-cell v-for="item in xxbqzjxxData" :key="item.cId">
                        <van-cell
                            title='证据类型'
                            :value=item.nzjlx
                            :key="item.cId"
                        ></van-cell>
                    </van-swipe-cell>
                </div>

                <!--行为信息-->
                <div v-if="xxbqjbxxData.nBqlx == '3'">
                    <Slogan theTitle="行为信息"/>
                    <van-swipe-cell
                        v-for="item in xxbqxwxxData"
                        :key="item.cid">
                        <van-cell
                            title='行为类型'
                            :value=item.nXwbqsx
                            :key="item.cId"
                        ></van-cell>
                    </van-swipe-cell>
                </div>
                <Slogan theTitle="上传材料"/>
                <div class="fd-upload-wrap">
                    <ac-preview-file
                        title="解除保全申请书"
                        :data="sqsclList"></ac-preview-file>
                    <ac-preview-file
                        title="其他材料"
                        :data="sqsclListQtcl"></ac-preview-file>
                </div>
            </div>
        </div>
</template>

<script>
import Slogan from '@/components/common/slogan'
import MyTitle from '../../components/common/myTitle'
import InfoTitle from '../../components/common/InfoTitle';
// import acUploadFile from '@/components/app/continuation-upload-file/index.vue';
// 预览文件
import acPreviewFile from '@/components/app/preview-file/index.vue';
import {mapGetters} from 'vuex'
import {getXxbqScclList, getXxbqxx, getXxDbxx} from "@/api/guarantee";
import {zjlxType, typeSqxbyy, xwsxType, typeCclx, typeTjrlx} from "@/filters";

export default {
    data() {
        return {
            active: 0,
            cId: this.$route.query.cId,
            sqsclList: [],
            sqsclListQtcl: [],
            // 解除保全基本信息
            xxbqjbxxData:{
                cSqfymc: "",
                cAh:"",
                cSqrxm:"",
                cSqxbyy:"",
                cTjrsf:"",
                dtCreatetime:"",
                cBz:"",
                nBqlx: ''
            },
        }
    },
    // 依赖
    provide() {
        return {
        }
    },
    components: {
        MyTitle,
        Slogan,
        InfoTitle,
        acPreviewFile,
    },
    computed: {
        ...mapGetters(['xxbqxwxxData', 'xxbqccxsData', 'xxbqzjxxData']),
    },
    methods: {
        //点击导航
        changeNav(navIndex) {
            this.active = navIndex
        },
        getData(){
            // getXxDbxx ({xbid: this.cId}).then(res=> {
            // }),
            getXxbqScclList ({xbid: this.cId}).then(res=> {
                console.log(res.data)
                this.sqsclList = res.data.sqs;
                this.sqsclListQtcl = res.data.qt;
            }),
            getXxbqxx({id: this.cId})
                .then(res => {
                    console.log('获取基本信息', res.data)
                    res.data.cSqxbyy = typeSqxbyy(res.data.cSqxbyy)
                  res.data.cTjrsf=typeTjrlx(res.data.cTjrsf);
                    res.data.dtCreatetime = this.timeFormat(res.data.dtCreatetime);
                    res.data.cBz = res.data.cBz ? res.data.cBz : '--';
                    Object.assign(this.xxbqjbxxData, res.data)
                    if (this.xxbqjbxxData.nBqlx === 1) {
                        this.$store.dispatch('GetXXBQCCXSList', {xbid:this.cId,bqid:''})
                            .then( res => {
                                res.data.map(function (item) {
                                    item.cCclx = typeCclx(item.cCclx);
                                })
                            })
                    } else if (this.xxbqjbxxData.nBqlx === 2) {
                        this.$store.dispatch('GetXXBQZJXXList', {xbid:this.cId,bqid:''})
                            .then( res => {
                                res.data.map(function (item) {
                                    item.nzjlx = zjlxType(item.nzjlx);
                                })
                            })
                    } else if (this.xxbqjbxxData.nBqlx === 3){
                        this.$store.dispatch('GetXXBQXWXXList', {xbid:this.cId,bqid:''})
                            .then( res => {
                                res.data.map(function (item) {
                                    item.nXwbqsx = xwsxType(item.nXwbqsx);
                                })
                            })
                    }

                })
                .catch(error => console.log(error))
        },
        timeFormat(currentTime) { // 时间格式化 2019-09-08
            let time =  new Date(currentTime);
            let year = time.getFullYear();
            let month = this.showTime(time.getMonth() + 1);
            let day = this.showTime(time.getDate());
            return year + '-' + month + '-' + day
        },
        // 封装一个不够两位数就补零的函数
        showTime(t) {
            let time
            time = t >= 10 ? t : '0' + t
            return time
        },
        goToScxxDeatil: function (xwxxItem, cId, index) {
            // sessionStorage.setItem("jcxwxxItem", JSON.stringify(xwxxItem));
            // sessionStorage.setItem("bqXwxxId", cId);
            this.$router.push({
                path: "/XxscxxDeatil",
                query: {
                    cId: this.cId,
                    index: index,
                    nBqlx: this.xxbqjbxxData.nBqlx,
                }
            });
        },
    },
    created(){
        this.getData();
    },
}
</script>

<style lang="less" scoped>
.guarantee-detail {
    .fd-upload-wrap {
        background-color: #fff;
    }
    .fd-nav {
        width: 100%;
        box-sizing: border-box;
        padding: 0 12px;
        display: flex;
        justify-content: space-between;
        line-height: 40px;
        background: #ffff;

        > span {
            font-size: 14px;
            color: #666666;
        }

        .span-active {
            color: #0683fc;
            cursor: pointer;
        }
    }
}
</style>
